import { render } from "./CharactersComponent.vue?vue&type=template&id=0bd751df&scoped=true"
import script from "./CharactersComponent.vue?vue&type=script&lang=js"
export * from "./CharactersComponent.vue?vue&type=script&lang=js"

import "./CharactersComponent.vue?vue&type=style&index=0&id=0bd751df&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd751df"]])

export default __exports__